import { BOX_SUB_STATE } from '../constants/space.const';

export const normalizeBoxStatus = status => String(status || '')
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/gu, '_');

const TRACKABLE_STATUSES = new Set([
    'PICKED_UP_FROM_WAREHOUSE',
    'PICKED_UP_FROM_CUSTOMER',
    'IN_TRANSIT',
    'DELIVERED_TO_WAREHOUSE'
]);

const NEW_BOX_ORDER_BEFORE_PICKUP_STATUSES = new Set([
    'AWAITING_PROCESSING',
    'PROCESSING',
    'SHIPPED_FROM_WAREHOUSE'
]);

function presentation({
    badgeText = null,
    listStatusText = null,
    trackingEligible = false
} = {}) {
    return {
        badgeText,
        listStatusText,
        trackingEligible
    };
}

export function isNewBoxOrderBeforePickup(box) {
    const status = normalizeBoxStatus(box?.status);
    const packingStatus = String(box?.packingStatus || '')
        .trim()
        .toLowerCase();

    return packingStatus === 'unpacked'
        && NEW_BOX_ORDER_BEFORE_PICKUP_STATUSES.has(status);
}

export function getBoxJourneyPresentation(box) {
    const status = normalizeBoxStatus(box?.status);
    const subState = box?.subState;

    if (isNewBoxOrderBeforePickup(box)) {
        return presentation({
            badgeText: 'Processing',
            listStatusText: 'Processing'
        });
    }

    if (TRACKABLE_STATUSES.has(status)) {
        return presentation({
            badgeText: "On it's way",
            trackingEligible: true
        });
    }

    if (subState === BOX_SUB_STATE.ARRIVING_REQUEST) {
        return presentation({ badgeText: 'Requested' });
    }

    if (
        subState === BOX_SUB_STATE.SENDING
        && status === 'READY_FOR_PICKUP'
    ) {
        return presentation({ badgeText: 'Scheduled' });
    }

    return presentation();
}
